export default __webpack_public_path__ + "static/media/main.c9131583.jpg";